import { useState } from "react";
import usePipedriveOrganizationSearch from "../../hooks/usePipedriveOrganizationSeach";
import IInputProps, { ISlimInputProps } from "./IInputProps";
import InputContainer, { InputContainerRow } from "./InputContainer";
import InputWithSearch from "./InputWithSearchFormikString";

export default <T,>({ name, label, formik, showNewLabel }: IPipedriveCompanyInputProps<T>) => {
    return (
        <InputContainer name={name} label={label} formik={formik}>
            <PipedriveCompanyInputSlim name={name} formik={formik} showNewLabel={showNewLabel} />
        </InputContainer>
    );
}

export const PipedriveCompanyInputRow = <T,>({ name, label, formik, showNewLabel }: IPipedriveCompanyInputProps<T>) => {
    return (
        <InputContainerRow name={name} label={label} formik={formik}>
            <PipedriveCompanyInputSlim name={name} formik={formik} showNewLabel={showNewLabel} />
        </InputContainerRow>
    );
}

export const PipedriveCompanyInputSlim = <T,>({ name, formik, showNewLabel }: IPipedriveCompanySlimInputProps<T>) => {
    const [query, setQuery] = useState(formik.values[name] as string || "");
    const searchResult = usePipedriveOrganizationSearch(query);

    return (
        <InputWithSearch
            name={name}
            formik={formik}
            debouncedOnChange={setQuery}
            searchResult={{
                query: query,
                items: searchResult,
            }}
            showNewLabel={showNewLabel ?? true}
        />
    );
}

interface IPipedriveCompanyInputProps<T> extends IInputProps<T, string> {
    showNewLabel?: boolean;
}

interface IPipedriveCompanySlimInputProps<T> extends ISlimInputProps<T, string> {
    showNewLabel?: boolean;
}